<div class="d-flex justify-content-center">
  <div class="cursor-pointer decrease-quantity" (click)="onDecreaseQuantity()"
       [ngClass]="{'opacity-3 pointer-events-none': (numberOfAddedProducts < 1)}">
    <i class="icon13 se-icon quantity-icons no-select"
       [ngClass]="{'opacity-6 pointer-events-none':(numberOfAddedProducts < 1)}">electricity_polarity_negative_minus</i>
  </div>
  <input appNumericValidationDirective [ngClass]="{'highlight-element' : currentStateInABom < numberOfAddedProducts, 'highlight-element-red' : currentStateInABom > numberOfAddedProducts}"
         type="number" min="0" [max]="maxNumberOfElements" [(ngModel)]="numberOfAddedProducts" (sanitizedChange)="changeNumberOfProducts()"  class="input-element">
  <div class="cursor-pointer increase-quantity" (click)="onIncreaseQuantity()"
       [ngClass]="{'opacity-3 pointer-events-none': (numberOfAddedProducts >= maxNumberOfElements)}">
    <i class="icon13 se-icon-electricity_polarity_positive_plus quantity-icons no-select"
       [ngClass]="{'opacity-6 pointer-events-none':(numberOfAddedProducts >= maxNumberOfElements)}"></i>
  </div>
</div>
